import { FormationDetailProps } from "@/types/formation";

export const hydrocurageImmoFormation: FormationDetailProps = {
  id: "13",
  title: "Formation Hydrocurage - Spécialisation Immobilier",
  description: "Cette formation permet d'acquérir les compétences nécessaires pour utiliser du mini-combiné correctement et en toute sécurité dans le secteur de l'immobilier.",
  duration: "7 heures (1 jour)",
  category: "Assainissement",
  imageSrc: "/images/formations/HydroPetitVehicule.webp",
  slug: "hydrocurage-immo",
  reference: "F-IMMO",
  price: "Sur devis – nous contacter",
  targetAudience: "Toute personne utilisant un mini-combiné, chauffeur et opérateur ou chef de bord",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médical",
  objectives: [
    "Maîtriser le matériel d'un mini-combiné correctement et en toute sécurité",
    "Connaître la législation",
    "Connaître les différentes pompes HP",
    "Connaître les principes de fonctionnement de l'hydroseuse",
    "Choisir le matériel",
    "Doser correctement l'outillage de curage adapté à la pompe HP"
  ],
  program: [
    {
      title: "Matin",
      items: [
        "Accueil des stagiaires relatives à l'utilisation du vélo",
        "Principe",
        "Rappel physique",
        "Les mini-combinés",
        "Les écoulements hydrauliques",
        "Cuiretage: présentation des fusées hydrauliques",
        "Pompe à palette (2,5 à 40 lit)",
        "Le bras d'aspiration",
        "Technique de recherche de pannes",
        "Répartition de charges (poids)",
        "Risque HP et sécurité",
        "Balisage chantier mobile"
      ]
    },
    {
      title: "PARTIE PRATIQUE",
      items: [
        "Recherche de la pompe HP et du circuit HP",
        "Présentation débit, perte de charge",
        "Choix des buses de curage",
        "Choix des fusées HP",
        "Procédure contre le gel",
        "Risques HP et sécurité"
      ]
    }
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, mise en situation pratique, exercice sur site"
  ],
  evaluationMethods: [
    "En 1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercices applicatifs",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  certification: "Cette action de formation sera validée par un certificat de réalisation nominative, après la réalisation du QCM final par l'évaluation des acquis.",
  effectif: "4 stagiaires minimum et 8 stagiaires maximum",
  registrationProcess: [
    "Inscription par téléphone, par mail ou par le site internet",
    "Délai d'accès selon un agenda interne de session de l'entreprise",
    "Inscription 15 jours avant le début de la formation"
  ],
  accessibilityCriteria: "Pour toute personne en situation d'handicap, Nous sommes susceptibles d'accueillir les personnes moins de nous contacter au préalable pour étudier toute situation.",
  formatterInfo: {
    name: "Sebastien Davrainville - SDPSI Formation",
    phone: "06.22.61.04.09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsi-formations.fr"
  }
};
